import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './styles/VideoModal.css';

const VideoModal = ({ videoSrc, title, isOpen, onClose }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
          onClose();
        }
      };
      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.body.style.overflow = 'unset';
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  const modalContent = createPortal(
    <div
      className="video-modal-backdrop"
      onClick={handleBackdropClick}
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          onClose();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label="Close video modal"
    >
      <div
        className="video-modal-content"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.stopPropagation();
          }
        }}
        role="presentation"
      >
        <button
          className="video-modal-close"
          onClick={onClose}
          aria-label="Close video modal"
        >
          ×
        </button>
        {title && <h2 className="video-modal-title">{title}</h2>}
        <div className="video-modal-player">
          <video
            ref={videoRef}
            src={videoSrc}
            controls
            autoPlay
            playsInline
            className="video-modal-video"
            aria-label={title || 'Video player'}
          >
            <track kind="captions" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>,
    document.body,
  );

  return modalContent;
};

export default VideoModal;
